import {Component, ElementRef, OnInit, Renderer2} from '@angular/core';

@Component({
  selector: 'cmp-li',
  template: `<span class="text-dark">
      <ng-content select="[left]"></ng-content>
    </span>
<span class="text-secondary font-weight-light">
      <ng-content select="[right]"></ng-content>
  </span>
`,
  styles: [`:host{display:block}`],
})
export class LiListTextComponent implements OnInit {

  classes = ['list-group-item', 'd-flex', 'justify-content-between', 'align-items-center'];

  constructor(private elRef: ElementRef, private renderer: Renderer2) {
  }

  ngOnInit() {
    this.classes.forEach(element => {
      this.renderer.addClass(this.elRef.nativeElement, element);
    });
  }

}
